<script setup>
// core
import {ref, computed, getCurrentInstance} from "vue";
import {useI18n} from "vue-i18n";
import {useStore} from "vuex";

// components
import ButtonLoading from "@/components/Recurring/ButtonLoading.vue";

// validate
import {validateEmail, validateEdrpou} from "@/helpers/dialogValidation";

const {t: $t} = useI18n();
const {proxy} = getCurrentInstance()
const store = useStore()
const dialogParams = computed(() => store.state.dialogParams);

const formData = ref({
    email: '',
    edrpou: '',
})

const errors = computed(() => ({
    email: validateEmail(formData.value.email, $t),
    edrpou: validateEdrpou(formData.value.edrpou, $t),
}))

const isSubmittable = computed(() => {
    const filled = !!formData.value.email.trim() && !!formData.value.edrpou.trim()

    return filled && !errors.value.email && !errors.value.edrpou
})

const isLoading = computed(() => store.getters['invoice/getIsCreateLoading'])

const handleSubmit = async () => {
    if (!isSubmittable.value) return

    await store.dispatch('invoice/createInvoice', {
        payload: {...formData.value, ...dialogParams.value},
        moshaToast: proxy.$moshaToast
    })
}
</script>

<template>
    <slot name="header_close"/>

    <div class="wrapper_dialog">
        <h3 class="title">{{ $t('invoice.form.title') }}</h3>

        <form class="content" @submit.prevent="handleSubmit">
            <div class="field">
                <p class="subtitle">{{ $t('invoice.form.email_label') }}</p>
                <input
                    v-model="formData.email"
                    :class="{ input_error: !!errors.email }"
                    :placeholder="$t('invoice.form.email_placeholder')"
                />
                <div class="input-errors" :class="{ 'is-shown': !!errors.email }">{{ errors.email }}</div>
            </div>

            <div class="field">
                <p class="subtitle">{{ $t('invoice.form.edrpou_label') }}</p>
                <input
                    v-model="formData.edrpou"
                    :class="{ input_error: !!errors.edrpou }"
                    :placeholder="$t('invoice.form.edrpou_placeholder')"
                />
                <div class="input-errors" :class="{ 'is-shown': !!errors.edrpou }">{{ errors.edrpou }}</div>
            </div>

            <div class="action_container">
                <ButtonLoading type="submit" :loading="isLoading" :disabled="isLoading || !isSubmittable">
                    {{ $t('invoice.form.submit') }}
                </ButtonLoading>
            </div>
        </form>
    </div>
</template>

<style lang="scss" scoped>
@use "@/styles/dialog-form.scss";
</style>
